import { render, staticRenderFns } from "./ResetFilters.vue?vue&type=template&id=023110a4&"
import script from "./ResetFilters.vue?vue&type=script&lang=js&"
export * from "./ResetFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports